import {createApp} from 'vue'
import FeaturedGroups from './FeaturedGroups'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'

const el = '.kb-component--featured-groups'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FeaturedGroupsDOM)=> {
            const props = handleComponentProps(FeaturedGroups, FeaturedGroupsDOM)
            const component = createApp(FeaturedGroups, props).use(Store)
            component.mount(FeaturedGroupsDOM)
        })
    }
}